import ActivateDeviceDialog from './activate-device-dialog-view'
export default ActivateDeviceDialog
